import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const c = {
  flamenco500: "#F05260",
  flamenco400: "#F47781",
  flamenco300: "#F6A2A9",
  flamenco100: "#F7D9DC",
  flamenco50: "#FBECEE",
  skyfall500: "#84D5F7",
  skyfall400: "#99DDF9",
  skyfall300: "#A7E2FB",
  skyfall200: "#B9E8FC",
  skyfall100: "#CBEFFF",
  mintleaf500: "#4EB969",
  mintleaf300: "#91DFA5",
  plumwood500: "#842885",
  plumwood400: "#B666B7",
  plumwood300: "#EA9BEB",
  plumwood200: "#F5BBF6",
  plumwood100: "#FBD5FB",
};

export const nav: NavPalette = {
  surface: "rgba(251, 213, 251, 0.88)",
  surfaceHover: "rgba(251, 213, 251, 0.96)",
  border: "rgba(182, 102, 183, 0.3)",
  text: "#842885",
  textMuted: "rgba(132, 40, 133, 0.7)",
  activeBg: "rgba(245, 187, 246, 0.75)",
  activeText: "#842885",
};
